<template>
  <div class="search-item individual col-12 col-lg-3 col-md-4 col-sm-12 col-xs-12 transition">         
    <div 
      :class="['search-item-wrap transition', itemClass]"
      @click="onItemClicked(page)"
    >
      <div class="search-item-image">
        <div
          class="event-banner" 
          :style="{ backgroundImage: `url(${page.eventImageUrl})` }"
        >
          <div
            class="event-banner-overlay" 
            :style="{ background: page.secondaryBgColor }"
          ></div>
        </div>
        <div class="item-image-wrapper">
          <a
            class="item-image" 
            :style="{ backgroundImage: `url(${encodeURI(page.imageUrl)})` }"
            :href="page.Url"
          >
          </a>
        </div>
      </div>
      <div class="search-item-desc">
        <p :title="page.title" class="page-title event-theme-h3-font-family">
          {{ page.title }}
        </p>
        <p class="eventname">
          {{ page.eventName }}
        </p>
        <p class="total event-theme-body-text-font-family">
          {{ getCurrencySymbol }}{{ raised }}
        </p>
        <div class="search-item-btns">
          <a
            :href="page.donateUrl"
            class="gf-driver-button search-item-donate transition search-item-btn event-theme-driver-button-font-family"
          >
            <span>Donate</span>
          </a>
          <template v-if="!hideJoinTeam && isTeam">
            <a
              :href="teamUrl"
              class="gf-secondary-border jointeam search-item-fundraise transition search-item-btn event-theme-driver-button-font-family"
            >
              Join Team
            </a>
          </template>
          
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FundraiserBoxRaiseMixin from '../FundraiserBoxRaiseMixin.vue';

export default {
  name: 'FundraiseBoxRaiseDesign1',
  mixins: [FundraiserBoxRaiseMixin],
}
</script>

<style scoped>

body {
	background-color: #fff;
}

body #banner{
	background: rgb(252, 218, 213);
	background: -moz-linear-gradient(90deg, rgba(252, 218, 213, 1) 0%, rgba(255, 238, 235, 1) 100%);
	background: -webkit-linear-gradient(90deg, rgba(252, 218, 213, 1) 0%, rgba(255, 238, 235, 1) 100%);
	background: linear-gradient(90deg, rgba(252, 218, 213, 1) 0%, rgba(255, 238, 235, 1) 100%);
	filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#fcdad5",endColorstr="#ffeeeb",GradientType=1);
	height: 125px;
}

.hideJoinTeam {
  visibility: hidden;
}

.search-item-wrap {
  min-height: 320px;
  border-radius: 7px;
  overflow: hidden;
  cursor:pointer;
  background:#fff;
  border: 1px solid #e2e2e2;
}

.search-item-wrap-no-join-team {
  min-height: 280px !important;
}

.search-item-image {
  background: #fff;
  padding: 10px;
}

.search-item-image .item-image {
  position: relative;
  outline: 1px solid #e6e6e6;
  outline-offset: -1px;
}

.search-item-image .item-image h3 {    
  background: rgba(0,0,0,0.4);
  color: #fff;
  font-size: 14px;
  padding: 5px 15px;
  position: absolute;
  width: 100%;
  bottom: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.item-image-wrapper {
  height: 130px;
  width: 130px;
  margin: -60px auto 0px;
  border-radius: 500px;
  background-color: #fff;
  display: block;
  overflow: hidden;
  position: relative;
}

.item-image {
  background-repeat: no-repeat;
  height: 120px;
  width: 120px;
  background-size: cover;
  background-position: center center;
  margin: 5px;
  border-radius: 500px;
  display: block;
  overflow: hidden;
}

#search-result.ben-search .item-image {
  background-size: contain;
  width: 85%;
  height: 120px;
  margin: 20px auto;
  border-radius: 0;
  background-color: transparent;
}

.search-item {
  padding: 10px;
  float: left;
}

.search-item-btns .search-item-btn {
  display: inline-block;
  margin-left: 0;
}

.search-item-btns {
  margin-bottom: 20px;
}

.search-item-btns a.search-item-fundraise {
  background: white;
  color: #333;
  border: 1px solid #333;
  font-weight: bold;
  border-radius: 5px;
  margin: 5px;
}

.search-item-btns a span.fa {
  margin-right: 7px;
}

.search-item-btns a.search-item-donate {
  background: #ef472b !important;
  color: #fff;
}

.search-item-btns .jointeam {
  background: white !important;
  border: 1px solid #1a3a49;
  margin-left: 10px !important;
}

.search-item-btns .jointeam:hover {
  opacity: 0.7;
}

.search-item-btns a {
  text-decoration: none;
  background: #f7f7f7;
  display: inline-block;
  margin: 10px auto;
  font-size: 14px;
  margin-left: 5px;
  padding: 8px 15px;
	width: 105px;
	font-weight: bold;
	border-radius: 5px;
	font-size: 13px !important;
}

.search-item-btns .team-buttons a {
  display: inline-block;
  width: 40%;
  margin: 0;
  font-size: 13px;
}

.search-item-btns a.secondarybtn {
  background: #1a3a49;
  color: #fff;
}

.search-item-btns a.primarybtn {
  background: #f47d32;
  color: #fff;
}

.search-item-btns a.lnkJoinTeam {
  color: #fff;
  background-image: none;
  background: none;
  background-color: #1a3a49;
  font-size: 14px !important;    
  border: 0;
  line-height: 14px !important;
  padding: 10px !important;
}

.search-item-btns a.lnkJoinTeam > span {
  background: none;
  color: #fff;    
  font-weight: normal;
  font-size: 14px !important;
  padding: 0;
  line-height: 14px !important;
  height: auto !important;
}

.search-item-wrap:hover {
  box-shadow: 0px 1px 12px 0.5px #CCC;
}

.search-item.appended {
  margin-top: 30px;
  opacity: 0;
}

.search-item-desc h3 {
  margin-bottom: 10px;
  font-weight: bold;
  margin: 15px auto 5px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  width: 80%;
}

.search-item-desc .page-title {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 0px 15px;
  font-weight: bold;
  margin-bottom: 5px;
  font-size: 16px;
}

.search-item p.eventname {
  width: 80%;
  margin: 0 auto 5px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  color: #999;
}

.search-item p.total {
  font-weight: bold;
  font-size: 16px;
}

.search-item a.lnkJoinTeam.button-gray.gray {
  display: none;
}

.event-banner {
  background-color: #e1e1e1;
  height: 80px;
  width: 100%;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  overflow: hidden;
  position: relative;
  opacity: 0.7;
  border-radius: 7px;
  transition: all 0.5s;
}

.event-banner:hover {
  opacity: 1;
  transition: all 0.5s;
}

.event-banner-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0.8;
  background: rgb(252 219 214) !important;
  transition: all .3s;
}

.event-banner-overlay:hover {
  opacity: 0;
}

.search-item-wrap:hover .event-banner-overlay {
  opacity: 0;
}

.search-item-wrap:hover .event-banner {
  opacity: 1;
}
</style>
